export const MsalAuthTypes = {
    AzureActiveDirectory: 'AzureActiveDirectory',
    AzureB2C: 'AzureB2C'
};